import axios from "axios";
const errorsHandler = require("@/services/errors")

//Change This
const module = 'analytics';

const state = {

}

const getters = {

}

const actions = {
    getReservationsBySport: async (context, filters = {}) => {
        const cleanFilters = {};
        Object.keys(filters).forEach(key => {
            if (filters[key]) cleanFilters[key] = filters[key]; // evita null/stringa "null"
        });

        const query = new URLSearchParams(cleanFilters).toString();
        const url = `api/v1/${module}/reservations-by-sport?${query}`;

        try {
            const response = await axios.get(
                `${context.rootGetters['settings/getEndpoint']}${url}`,
                {
                    headers: {
                        Authorization: `Bearer ${context.rootGetters['user/getUser'].token}`
                    }
                }
            );
            return response.data.result;
        } catch (error) {
            return errorsHandler.errorHandler(error);
        }
    },
    getReservationsByUser: async (context, filters = {}) => {
        const cleanFilters = {};
        Object.keys(filters).forEach(key => {
            if (filters[key]) cleanFilters[key] = filters[key]; // evita null/stringa "null"
        });

        const query = new URLSearchParams(cleanFilters).toString();
        const url = `api/v1/${module}/reservations-by-user?${query}`;

        try {
            const response = await axios.get(
                `${context.rootGetters['settings/getEndpoint']}${url}`,
                {
                    headers: {
                        Authorization: `Bearer ${context.rootGetters['user/getUser'].token}`
                    }
                }
            );
            return response.data.result;
        } catch (error) {
            return errorsHandler.errorHandler(error);
        }
    },
    getReservationsByCenter: async (context, filters = {}) => {
        const cleanFilters = {};
        Object.keys(filters).forEach(key => {
            if (filters[key]) cleanFilters[key] = filters[key]; // evita null/stringa "null"
        });

        const query = new URLSearchParams(cleanFilters).toString();
        const url = `api/v1/${module}/reservations-by-center?${query}`;

        try {
            const response = await axios.get(
                `${context.rootGetters['settings/getEndpoint']}${url}`,
                {
                    headers: {
                        Authorization: `Bearer ${context.rootGetters['user/getUser'].token}`
                    }
                }
            );
            return response.data.result;
        } catch (error) {
            return errorsHandler.errorHandler(error);
        }
    },

    getReservationBySlotAndWeekday: async (context, filters = {}) => {
        const cleanFilters = {};
        Object.keys(filters).forEach(key => {
            if (filters[key]) cleanFilters[key] = filters[key]; // evita null/stringa "null"
        });

        const query = new URLSearchParams(cleanFilters).toString();
        const url = `api/v1/${module}/reservations-by-slot-weekday?${query}`;

        try {
            const response = await axios.get(
                `${context.rootGetters['settings/getEndpoint']}${url}`,
                {
                    headers: {
                        Authorization: `Bearer ${context.rootGetters['user/getUser'].token}`
                    }
                }
            );
            return response.data.result;
        } catch (error) {
            return errorsHandler.errorHandler(error);
        }
    },

    getReservationsByGeo: async (context, filters = {}) => {
        const cleanFilters = {};
        Object.keys(filters).forEach(key => {
            if (filters[key]) cleanFilters[key] = filters[key]; // evita null/stringa "null"
        });

        const query = new URLSearchParams(cleanFilters).toString();
        const url = `api/v1/${module}/reservations-by-geo?${query}`;

        try {
            const response = await axios.get(
                `${context.rootGetters['settings/getEndpoint']}${url}`,
                {
                    headers: {
                        Authorization: `Bearer ${context.rootGetters['user/getUser'].token}`
                    }
                }
            );
            return response.data.result;
        } catch (error) {
            return errorsHandler.errorHandler(error);
        }
    },
    getReservationsByDate: async (context, filters = {}) => {
        const cleanFilters = {};
        Object.keys(filters).forEach(key => {
            if (filters[key]) cleanFilters[key] = filters[key]; // evita null/stringa "null"
        });

        const query = new URLSearchParams(cleanFilters).toString();
        const url = `api/v1/${module}/reservations-by-date?${query}`;

        try {
            const response = await axios.get(
                `${context.rootGetters['settings/getEndpoint']}${url}`,
                {
                    headers: {
                        Authorization: `Bearer ${context.rootGetters['user/getUser'].token}`
                    }
                }
            );
            return response.data.result;
        } catch (error) {
            return errorsHandler.errorHandler(error);
        }
    },
    getReservationAmountByMonth: async (context, filters = {}) => {
        const cleanFilters = {};
        Object.keys(filters).forEach(key => {
            if (filters[key]) cleanFilters[key] = filters[key]; // evita null/stringa "null"
        });

        const query = new URLSearchParams(cleanFilters).toString();
        const url = `api/v1/${module}/reservations-amount-by-month?${query}`;

        try {
            const response = await axios.get(
                `${context.rootGetters['settings/getEndpoint']}${url}`,
                {
                    headers: {
                        Authorization: `Bearer ${context.rootGetters['user/getUser'].token}`
                    }
                }
            );
            return response.data.result;
        } catch (error) {
            return errorsHandler.errorHandler(error);
        }
    },
}


const mutations = {

}


export default {
    namespaced : true,
    state,
    mutations,
    getters,
    actions
}

